import EvaluacionService from '@/services/Evaluacion'
import axios from '@/utils/axios'

const actions = {
  async iniciarEvaluacion (context: any, activityScheduleId: number) {
    const service = new EvaluacionService(axios)
    const data = await service.iniciar(activityScheduleId)
    context.commit('setEvaluacionActiva', {
      reviewsAnswerId: data.reviewsAnswerId,
      preguntas: data.preguntas,
      tiempoDisponible: data.tiempoDisponible
    })
    return data
  },

  async responderEvaluacion (context: any, payload: { reviewsAnswerId: number, respuestas: any[], tiempoTranscurrido: string }) {
    const service = new EvaluacionService(axios)
    const resultado = await service.responder(payload.reviewsAnswerId, payload.respuestas, payload.tiempoTranscurrido)
    context.commit('setResultado', resultado)
    return resultado
  },

  async consultarResultado (context: any, reviewsAnswerId: number) {
    const service = new EvaluacionService(axios)
    const resultado = await service.consultarResultado(reviewsAnswerId)
    return resultado
  },

  limpiarEvaluacion (context: any) {
    context.commit('limpiarEvaluacion')
  }
}

export default actions
